import { AfterViewInit, Component, Input, NgZone } from "@angular/core";

import {
  BuildingService,
  PathService,
  ScoutPointPhotoService,
} from "../../core/services";
import { KmlViewerComponent } from "../../shared/mapping/kml/kml-viewer/kml-viewer.component";
import { PathKmlBuilder } from "./path-kml-builder";
import { WaypointTableRow } from "../../core/models/path-waypoint";

@Component({
  selector: "fes-path-kml-viewer",
  templateUrl: "../../shared/mapping/kml/kml-viewer/kml-viewer.component.html",
  styleUrls: ["../../shared/mapping/kml/kml-viewer/kml-viewer.component.scss"],
})
export class PathKmlViewerComponent
  extends KmlViewerComponent
  implements AfterViewInit
{
  @Input() waypointPaths: {
    pathId: string;
    mapWaypointRows: WaypointTableRow[];
  }[];

  constructor(
    ngZone: NgZone,
    buildingService: BuildingService,
    public pathService: PathService,
    photoService: ScoutPointPhotoService
  ) {
    super(ngZone, buildingService, photoService);
  }

  ngAfterViewInit(): void {
    this.init();
  }

  override async init() {
    try {
      this.paths = this.waypointPaths
        .map(PathKmlBuilder.waypointPathAsKmlBuilderPath)
        .sort((a, b) => a.id.localeCompare(b.id));
      // console.log("this.paths", this.paths);
      await super.init();
    } catch (error: any) {
      console.error(error);
    }
  }
}
